
import React, { useState, useEffect } from "react";
import Image from "react-bootstrap/esm/Image";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Button from 'react-bootstrap/Button'
import { Link, Redirect } from "react-router-dom";
import api from "../../services/api";

export default function Listanoticias() {
 // pág atual e numero de pags
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [nrofpages, setNumberofpage] = useState(1);
  
  // chama api de acordo com numero de pags
  useEffect(() => {
    api.get("/noticia?per_page=5", {    
        params: { page: page }
      }).then(response => {
        // total de pags
        setNumberofpage(response.headers["x-wp-totalpages"]);
        setPosts(response.data);
      }).catch(error => {
          return <Redirect to='/not_found/'/>
    });
    }, [page, setPosts]);


  // pag anterior
  const handlePrevPage = () => setPage(page - 1 ? page - 1 : 1);
  // pag posterior
  const handleNextPage = () => setPage(page < nrofpages ? page + 1 : nrofpages);

  return (
    <div className="py-0">
      <div>
        {posts &&
          posts.length &&
          posts.map((post, index) => {
            return (
              <div key={post.id} >
               <Row className="py-5">
                  <Col sm={3}>
                     <Image src={post.imagem_destacada.guid} className="img-fluid rounded" />
                  </Col>
                  <Col sm={9}>
                     <h2>{post.title.rendered}</h2>
                     <div
                        dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}
                     />
                     <Link to={`/noticia/${post.slug}`}>
                        <button className="btn btn-light btn-sm mt-3"> leia mais</button>
                     </Link>
                  </Col>
               </Row>
              </div>
            );         
          })}
      </div>
      <div className="small mt-5 pt-5">
         <hr></hr>
           <p>Página {page} de {nrofpages} </p>
           <Button onClick={handlePrevPage} variant="outline-secondary" size="sm">Anterior</Button> 
           <Button onClick={handleNextPage} variant="outline-secondary" size="sm" className="mx-2">Próxima</Button>
      </div>
    </div>
  );
}